

// var urlString =  process.env.REACT_APP_API_URL_PROD
var urlString =  process.env.REACT_APP_API_URL
// var urlString = "http://192.168.1.173:8081/"
// var urlString = "http://localhost:8081"

export const PdfApiUrl = `${urlString}AddMediaS3`;
export const ImageApiUrl = `${urlString}AddMediaS3`;
